module.exports = __webpack_public_path__ + "static/bluesafarihamper-808fef474eadd55b3e7ee88dfda4bb37.jpeg";